module.exports = __webpack_public_path__ + "img/0eaaec3.jpg";